import { LimitType } from 'legoland-sdk/dist/experimental';
import BooleanLimitEditor from './BooleanLimitEditor';
import CountLimitEditor from './CountLimitEditor';
import DateLimitEditor from './DateLimitEditor';
import DateRangeLimitEditor from './DateRangeLimitEditor';
import GeoLimitEditor from './GeoLimitEditor';
import KmLimitEditor from './KmLimitEditor';
import { LimitEditor } from './LimitEditorTypes';
import { MortonIdsLimitEditor } from './MortonIdsLimitEditor';
import MultiSelectLimitEditor from './MultiSelectLimitEditor';
import SelectLimitEditor from './SelectLimitEditor';
import SquareKmLimitEditor from './SquareKmLimitEditor';

const limitToComponentMap: Record<LimitType, LimitEditor> = {
  [LimitType.Boolean]: BooleanLimitEditor,
  [LimitType.Count]: CountLimitEditor,
  [LimitType.Date]: DateLimitEditor,
  [LimitType.DateRange]: DateRangeLimitEditor,
  [LimitType.Geo]: GeoLimitEditor,
  [LimitType.Km]: KmLimitEditor,
  [LimitType.SquareKm]: SquareKmLimitEditor,
  [LimitType.Select]: SelectLimitEditor,
  [LimitType.MultiSelect]: MultiSelectLimitEditor,
  [LimitType.MortonIds]: MortonIdsLimitEditor,
};

export function getLimitEditorComponent(type: LimitType) {
  if (!limitToComponentMap[type]) {
    console.error(`Limit component for type "${type}" does not exist.`);
    return null;
  }
  return limitToComponentMap[type];
}
